import React, { useState } from 'react';
import { 
    Layout, 
    Card, 
    Table, 
    Button, 
    Space, 
    Input, 
    Switch, 
    Modal, 
    Form, 
    message, 
    Typography,
    Popconfirm,
    Menu,
    Tooltip,
    Select,
    ConfigProvider,
    Segmented,
    Tree,
    Empty
} from 'antd';
import { 
    SearchOutlined, 
    ReloadOutlined, 
    EditOutlined, 
    DeleteOutlined,
    LockOutlined,
    FolderOutlined,
    ExclamationCircleOutlined,
    ApartmentOutlined
} from '@ant-design/icons';
import zhCN from 'antd/lib/locale/zh_CN';

const { Sider, Content } = Layout;
const { Title, Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const ProduceAccount = () => {
    // 身份切换：enterprise=企业用户 / platform=平台用户
    const [identity, setIdentity] = useState('enterprise');

    // ============ 企业用户状态 ============
    const [selectedGroup, setSelectedGroup] = useState('1'); // 默认选中分组1
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    // 模拟分组数据
    const [groups, setGroups] = useState([
        { id: '1', name: '默认分组', isDefault: true },
        { id: '2', name: '华东生产部', isDefault: false },
        { id: '3', name: '华南外协厂', isDefault: false },
    ]);

    // 模拟账号数据 (按分组ID key 映射)
    const [accountsData, setAccountsData] = useState({
        '1': [
            { id: '101', account: 'admin_test_01', status: true, remark: '系统默认测试账号', createTime: '2026-03-01 10:00:00' },
            { id: '102', account: 'tester_02', status: false, remark: '临时测试用', createTime: '2026-03-05 14:20:00' },
            { id: '103', account: 'prod_worker_03', status: true, remark: '白班产线', createTime: '2026-03-06 09:00:00' },
            { id: '104', account: 'prod_worker_04', status: true, remark: '白班产线', createTime: '2026-03-06 09:05:00' },
            { id: '105', account: 'prod_worker_05', status: true, remark: '白班产线', createTime: '2026-03-06 09:10:00' },
            { id: '106', account: 'night_shift_01', status: true, remark: '夜班产线', createTime: '2026-03-06 20:00:00' },
            { id: '107', account: 'night_shift_02', status: false, remark: '设备检修停用', createTime: '2026-03-06 20:30:00' },
            { id: '108', account: 'qc_tester_01', status: true, remark: '质检专座', createTime: '2026-03-07 11:00:00' },
            { id: '109', account: 'qc_tester_02', status: true, remark: '质检专座', createTime: '2026-03-07 11:15:00' },
            { id: '110', account: 'factory_01_node', status: true, remark: '1号厂房节点', createTime: '2026-03-08 15:00:00' },
            { id: '111', account: 'factory_02_node', status: true, remark: '2号厂房节点', createTime: '2026-03-08 15:30:00' },
            { id: '112', account: 'temp_staff_01', status: true, remark: '临时工账号', createTime: '2026-03-09 10:00:00' },
            { id: '113', account: 'temp_staff_02', status: true, remark: '临时工账号', createTime: '2026-03-09 10:10:00' },
            { id: '114', account: 'repair_01', status: true, remark: '售后维修部', createTime: '2026-03-10 13:00:00' },
            { id: '115', account: 'test_auto_01', status: true, remark: '自动化自动脚本', createTime: '2026-03-11 08:00:00' },
        ],
        '2': [
            { id: '201', account: 'east_prod_88', status: true, remark: '华东1号线专用', createTime: '2026-03-10 09:15:00' },
        ],
        '3': []
    });

    // ============ 平台用户状态 ============
    // 模拟企业数据
    const [platformEnterprises] = useState([
        { id: 'ent1', name: '杭州万物互联有限公司' },
        { id: 'ent2', name: '深圳智能制造科技有限公司' },
        { id: 'ent3', name: '东莞电子制造有限公司' },
        { id: 'ent4', name: '苏州精工电子有限公司' },
    ]);

    // 模拟分组数据（含企业归属）
    const [platformGroups, setPlatformGroups] = useState([
        { id: 'ent1_g1', enterpriseId: 'ent1', name: '默认分组', isDefault: true },
        { id: 'ent1_g2', enterpriseId: 'ent1', name: '华东生产部', isDefault: false },
        { id: 'ent1_g3', enterpriseId: 'ent1', name: '华南外协厂', isDefault: false },
        { id: 'ent2_g1', enterpriseId: 'ent2', name: '默认分组', isDefault: true },
        { id: 'ent2_g2', enterpriseId: 'ent2', name: '白班产线', isDefault: false },
        { id: 'ent3_g1', enterpriseId: 'ent3', name: '默认分组', isDefault: true },
        { id: 'ent4_g1', enterpriseId: 'ent4', name: '默认分组', isDefault: true },
    ]);

    // 模拟账号数据（按分组ID key 映射）
    const [platformAccountsData, setPlatformAccountsData] = useState({
        'ent1_g1': [
            { id: 'p101', account: 'admin_test_01', status: true, remark: '系统默认测试账号', createTime: '2026-03-01 10:00:00' },
            { id: 'p102', account: 'prod_worker_03', status: true, remark: '白班产线', createTime: '2026-03-06 09:00:00' },
            { id: 'p103', account: 'night_shift_01', status: true, remark: '夜班产线', createTime: '2026-03-06 20:00:00' },
            { id: 'p104', account: 'qc_tester_01', status: true, remark: '质检专座', createTime: '2026-03-07 11:00:00' },
        ],
        'ent1_g2': [
            { id: 'p201', account: 'east_prod_88', status: true, remark: '华东1号线专用', createTime: '2026-03-10 09:15:00' },
        ],
        'ent1_g3': [],
        'ent2_g1': [
            { id: 'p301', account: 'sz_worker_01', status: true, remark: '深圳总装线', createTime: '2026-03-12 10:00:00' },
        ],
        'ent2_g2': [],
        'ent3_g1': [],
        'ent4_g1': [],
    });

    const [platformSelectedGroup, setPlatformSelectedGroup] = useState(null); // 选中二级分组
    const [platformSelectedRowKeys, setPlatformSelectedRowKeys] = useState([]);
    const [enterpriseSearch, setEnterpriseSearch] = useState('');
    const [platformExpandedKeys, setPlatformExpandedKeys] = useState(platformEnterprises.map(e => e.id));

    // ============ 弹窗状态 ============
    const [isAddAccountModalVisible, setIsAddAccountModalVisible] = useState(false);
    const [isResetPwdModalVisible, setIsResetPwdModalVisible] = useState(false);
    const [isGroupModalVisible, setIsGroupModalVisible] = useState(false);
    const [isMoveGroupModalVisible, setIsMoveGroupModalVisible] = useState(false);
    const [editingGroup, setEditingGroup] = useState(null);
    const [currentAccount, setCurrentAccount] = useState(null);

    const [isPlatformGroupModalVisible, setIsPlatformGroupModalVisible] = useState(false);
    const [isPlatformAddAccountModalVisible, setIsPlatformAddAccountModalVisible] = useState(false);
    const [isPlatformMoveGroupModalVisible, setIsPlatformMoveGroupModalVisible] = useState(false);

    const [form] = Form.useForm();
    const [resetPwdForm] = Form.useForm();
    const [groupForm] = Form.useForm();
    const [moveGroupForm] = Form.useForm();
    const [platformGroupForm] = Form.useForm();
    const [platformAccountForm] = Form.useForm();
    const [platformMoveForm] = Form.useForm();

    // 监听平台弹窗内「企业」选择，用于控制分组下拉是否置灰
    const platformAccountEnterpriseId = Form.useWatch('enterpriseId', platformAccountForm);
    const platformMoveEnterpriseId = Form.useWatch('enterpriseId', platformMoveForm);

    // ============ 企业用户：分组选择 ============
    const onSelectGroup = (key) => {
        setSelectedGroup(key);
        setSelectedRowKeys([]);
    };

    // 企业用户：分组增改
    const handleGroupSubmit = () => {
        groupForm.validateFields().then(values => {
            if (editingGroup) {
                setGroups(groups.map(g => g.id === editingGroup.id ? { ...g, name: values.name } : g));
                message.success('分组修改成功');
            } else {
                const newId = Date.now().toString();
                setGroups([...groups, { id: newId, name: values.name, isDefault: false }]);
                setAccountsData({ ...accountsData, [newId]: [] });
                message.success('分组创建成功');
            }
            setIsGroupModalVisible(false);
        });
    };

    // 企业用户：删除分组
    const deleteGroup = (id) => {
        const accounts = accountsData[id] || [];
        if (accounts.length > 0) {
            Modal.warning({
                title: '分组下存在产测账号不可删除！',
                okText: '我知道了',
                centered: true
            });
            return;
        }
        setGroups(groups.filter(g => g.id !== id));
        if (selectedGroup === id) setSelectedGroup('1');
        message.success('分组已删除');
    };

    // 企业用户：行选择
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    // 企业用户：移动分组
    const handleEnterpriseMoveGroup = () => {
        moveGroupForm.validateFields().then(values => {
            const targetGroupId = values.targetGroup;
            const targetGroupName = groups.find(g => g.id === targetGroupId)?.name;
            const sourceAccounts = accountsData[selectedGroup].filter(acc => selectedRowKeys.includes(acc.id));
            const remainingSourceAccounts = accountsData[selectedGroup].filter(acc => !selectedRowKeys.includes(acc.id));
            setAccountsData({
                ...accountsData,
                [selectedGroup]: remainingSourceAccounts,
                [targetGroupId]: [...(accountsData[targetGroupId] || []), ...sourceAccounts]
            });
            setSelectedRowKeys([]);
            message.success(`已成功将所选账号移动至 ${targetGroupName}`);
            setIsMoveGroupModalVisible(false);
            moveGroupForm.resetFields();
        });
    };

    // 企业用户：新增账号
    const handleEnterpriseAddAccount = () => {
        form.validateFields().then(values => {
            const newAccount = {
                id: Date.now().toString(),
                account: values.account,
                status: values.status,
                remark: values.remark || '-',
                createTime: new Date().toLocaleString(),
            };
            const newData = { ...accountsData };
            newData[selectedGroup] = [newAccount, ...(newData[selectedGroup] || [])];
            setAccountsData(newData);
            message.success('新增账号成功');
            setIsAddAccountModalVisible(false);
        });
    };

    // ============ 平台用户：企业查询 ============
    const handleEnterpriseSearch = (value) => {
        setEnterpriseSearch(value);
        const ids = platformEnterprises.filter(e => e.name.includes(value.trim())).map(e => e.id);
        setPlatformExpandedKeys(ids);
    };

    const filteredPlatformEnterprises = platformEnterprises.filter(e => e.name.includes(enterpriseSearch.trim()));

    const platformTreeData = filteredPlatformEnterprises.map(ent => ({
        key: ent.id,
        title: ent.name,
        icon: <ApartmentOutlined />,
        selectable: false,
        children: platformGroups.filter(g => g.enterpriseId === ent.id).map(g => ({
            key: g.id,
            title: g.name,
            icon: <FolderOutlined />,
        })),
    }));

    // 平台用户：根据企业取分组选项
    const getPlatformGroupOptions = (enterpriseId) =>
        platformGroups.filter(g => g.enterpriseId === enterpriseId);

    const enterpriseOptions = platformEnterprises.map(e => (
        <Option key={e.id} value={e.id}>{e.name}</Option>
    ));
    const enterpriseFilterOption = (input, option) =>
        (option?.children ?? '').toLowerCase().includes(input.toLowerCase());

    // 平台用户：创建分组
    const handlePlatformGroupSubmit = () => {
        platformGroupForm.validateFields().then(values => {
            const newId = `${values.enterpriseId}_g${Date.now()}`;
            setPlatformGroups([...platformGroups, { id: newId, enterpriseId: values.enterpriseId, name: values.name, isDefault: false }]);
            setPlatformAccountsData({ ...platformAccountsData, [newId]: [] });
            message.success('分组创建成功');
            setIsPlatformGroupModalVisible(false);
        });
    };

    // 平台用户：新增账号
    const handlePlatformAddAccount = () => {
        platformAccountForm.validateFields().then(values => {
            const newAccount = {
                id: Date.now().toString(),
                account: values.account,
                status: values.status,
                remark: values.remark || '-',
                createTime: new Date().toLocaleString(),
            };
            setPlatformAccountsData({
                ...platformAccountsData,
                [values.groupId]: [newAccount, ...(platformAccountsData[values.groupId] || [])]
            });
            message.success('新增账号成功');
            setIsPlatformAddAccountModalVisible(false);
        });
    };

    // 平台用户：移动分组
    const handlePlatformMoveGroup = () => {
        platformMoveForm.validateFields().then(values => {
            const targetGroupId = values.targetGroupId;
            const targetGroupName = platformGroups.find(g => g.id === targetGroupId)?.name;
            const sourceAccounts = platformAccountsData[platformSelectedGroup].filter(acc => platformSelectedRowKeys.includes(acc.id));
            const remainingSourceAccounts = platformAccountsData[platformSelectedGroup].filter(acc => !platformSelectedRowKeys.includes(acc.id));
            setPlatformAccountsData({
                ...platformAccountsData,
                [platformSelectedGroup]: remainingSourceAccounts,
                [targetGroupId]: [...(platformAccountsData[targetGroupId] || []), ...sourceAccounts]
            });
            setPlatformSelectedRowKeys([]);
            message.success(`已成功将所选账号移动至 ${targetGroupName}`);
            setIsPlatformMoveGroupModalVisible(false);
            platformMoveForm.resetFields();
        });
    };

    // ============ 账号表格列（企业/平台共用构建） ============
    const buildColumns = (activeKey, dataMap, setDataMap) => [
        { title: '登录账号', dataIndex: 'account', key: 'account' },
        {
            title: (
                <Space size={4}>
                    账号状态
                    <Tooltip title="关闭后，账号不可登录">
                        <ExclamationCircleOutlined style={{ color: '#bfbfbf', cursor: 'pointer' }} />
                    </Tooltip>
                </Space>
            ),
            dataIndex: 'status',
            key: 'status',
            render: (checked, record) => (
                <Switch
                    checked={checked}
                    onChange={(val) => {
                        const newData = { ...dataMap };
                        newData[activeKey] = (newData[activeKey] || []).map(item =>
                            item.id === record.id ? { ...item, status: val } : item
                        );
                        setDataMap(newData);
                    }}
                />
            )
        },
        { title: '备注信息', dataIndex: 'remark', key: 'remark', ellipsis: true },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime' },
        {
            title: '操作',
            key: 'action',
            render: (_, record) => (
                <Space>
                    <Button type="link" size="small" icon={<LockOutlined />} onClick={() => {
                        setCurrentAccount(record);
                        setIsResetPwdModalVisible(true);
                    }}>重置密码</Button>
                    <Popconfirm
                        title="确定删除该账号吗？"
                        description="删除后将无法恢复，请谨慎操作。"
                        onConfirm={() => {
                            const newData = { ...dataMap };
                            newData[activeKey] = (newData[activeKey] || []).filter(item => item.id !== record.id);
                            setDataMap(newData);
                            message.success('账号已删除');
                        }}
                        okText="确定"
                        cancelText="取消"
                    >
                        <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
                    </Popconfirm>
                </Space>
            )
        },
    ];

    const enterpriseColumns = buildColumns(selectedGroup, accountsData, setAccountsData);
    const platformColumns = buildColumns(platformSelectedGroup, platformAccountsData, setPlatformAccountsData);

    const currentGroupName = groups.find(g => g.id === selectedGroup)?.name || '';
    const currentPlatformGroup = platformGroups.find(g => g.id === platformSelectedGroup);
    const currentEnterprise = platformEnterprises.find(e => e.id === currentPlatformGroup?.enterpriseId);

    const enterpriseRowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const platformRowSelection = {
        selectedRowKeys: platformSelectedRowKeys,
        onChange: (keys) => setPlatformSelectedRowKeys(keys),
    };

    // ============ 渲染：企业用户 ============
    const renderEnterprise = () => (
        <Layout style={{ minHeight: '100vh', background: '#fff' }}>
            {/* 左侧分组 */}
            <Sider width={280} theme="light" style={{ borderRight: '1px solid #f0f0f0', marginRight: 24 }}>
                <div style={{ padding: '0 12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Title level={4} style={{ margin: 0 }}>产测分组</Title>
                    <Button type="primary" size="small" onClick={() => {
                        setEditingGroup(null);
                        groupForm.resetFields();
                        setIsGroupModalVisible(true);
                    }}>创建分组</Button>
                </div>
                <Menu
                    mode="inline"
                    selectedKeys={[selectedGroup]}
                    onClick={({ key }) => onSelectGroup(key)}
                    style={{ borderRight: 'none' }}
                >
                    {groups.map(g => (
                        <Menu.Item
                            key={g.id}
                            icon={<FolderOutlined />}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >
                            <span style={{ flex: 1 }}>{g.name}</span>
                            {!g.isDefault && (
                                <span onClick={(e) => e.stopPropagation()} style={{ marginLeft: 8 }}>
                                    <EditOutlined
                                        style={{ fontSize: 12, marginRight: 12, color: '#1890ff' }}
                                        onClick={() => {
                                            setEditingGroup(g);
                                            groupForm.setFieldsValue({ name: g.name });
                                            setIsGroupModalVisible(true);
                                        }}
                                    />
                                    {accountsData[g.id]?.length > 0 ? (
                                        <Tooltip title="分组下存在产测账号不可删除！">
                                            <DeleteOutlined style={{ fontSize: 12, color: '#d9d9d9', cursor: 'not-allowed' }} />
                                        </Tooltip>
                                    ) : (
                                        <Popconfirm
                                            title="确定删除此分组吗？"
                                            onConfirm={() => deleteGroup(g.id)}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <DeleteOutlined style={{ fontSize: 12, color: '#ff4d4f' }} />
                                        </Popconfirm>
                                    )}
                                </span>
                            )}
                        </Menu.Item>
                    ))}
                </Menu>
            </Sider>

            {/* 右侧列表 */}
            <Content>
                <Card bordered={false} bodyStyle={{ padding: 0 }}>
                    <div style={{ marginBottom: 24 }}>
                        <Form layout="inline">
                            <Form.Item label="登录账号">
                                <Input placeholder="请输入登录账号" prefix={<SearchOutlined />} allowClear />
                            </Form.Item>
                            <Form.Item>
                                <Space>
                                    <Button type="primary">查询</Button>
                                    <Button icon={<ReloadOutlined />}>重置</Button>
                                </Space>
                            </Form.Item>
                        </Form>
                    </div>

                    <div style={{ marginBottom: 16 }}>
                        <Space size={12}>
                            <Button type="primary" onClick={() => {
                                form.resetFields();
                                form.setFieldsValue({ group: currentGroupName });
                                setIsAddAccountModalVisible(true);
                            }}>
                                添加产测账号
                            </Button>
                            <Button
                                style={{
                                    backgroundColor: selectedRowKeys.length >= 1 ? '#faad14' : '#f5f5f5',
                                    borderColor: selectedRowKeys.length >= 1 ? '#faad14' : '#d9d9d9',
                                    color: selectedRowKeys.length >= 1 ? '#fff' : 'rgba(0, 0, 0, 0.25)',
                                    borderRadius: '4px'
                                }}
                                disabled={selectedRowKeys.length === 0}
                                onClick={() => setIsMoveGroupModalVisible(true)}
                            >
                                移动分组
                            </Button>
                        </Space>
                    </div>

                    <Table
                        rowSelection={enterpriseRowSelection}
                        columns={enterpriseColumns}
                        dataSource={accountsData[selectedGroup] || []}
                        rowKey="id"
                        pagination={{
                            showSizeChanger: true,
                            showTotal: (total) => `共 ${total} 条记录`,
                        }}
                    />
                </Card>
            </Content>
        </Layout>
    );

    // ============ 渲染：平台用户 ============
    const renderPlatform = () => (
        <Layout style={{ minHeight: '100vh', background: '#fff' }}>
            {/* 左侧：企业 -> 分组 二级树 */}
            <Sider width={320} theme="light" style={{ borderRight: '1px solid #f0f0f0', marginRight: 24 }}>
                <div style={{ padding: '0 12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Title level={4} style={{ margin: 0 }}>产测分组</Title>
                    <Button type="primary" size="small" onClick={() => {
                        platformGroupForm.resetFields();
                        setIsPlatformGroupModalVisible(true);
                    }}>创建分组</Button>
                </div>
                <div style={{ padding: '0 12px 12px' }}>
                    <Input
                        placeholder="查询企业"
                        prefix={<SearchOutlined />}
                        allowClear
                        value={enterpriseSearch}
                        onChange={(e) => handleEnterpriseSearch(e.target.value)}
                    />
                </div>
                <div style={{ height: 520, overflowY: 'auto', padding: '0 4px' }}>
                    {filteredPlatformEnterprises.length > 0 ? (
                        <Tree
                            showIcon
                            blockNode
                            treeData={platformTreeData}
                            selectedKeys={platformSelectedGroup ? [platformSelectedGroup] : []}
                            expandedKeys={platformExpandedKeys}
                            onExpand={(keys) => setPlatformExpandedKeys(keys)}
                            onSelect={(keys) => {
                                const key = keys[0];
                                if (key && platformGroups.some(g => g.id === key)) {
                                    setPlatformSelectedGroup(key);
                                    setPlatformSelectedRowKeys([]);
                                }
                            }}
                        />
                    ) : (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="未找到企业" style={{ marginTop: 40 }} />
                    )}
                </div>
            </Sider>

            {/* 右侧列表 */}
            <Content>
                {!platformSelectedGroup ? (
                    <Empty description="请选择左侧分组查看账号" style={{ marginTop: 120 }} />
                ) : (
                    <Card bordered={false} bodyStyle={{ padding: 0 }}>
                        <div style={{ marginBottom: 16 }}>
                            <Text type="secondary">{currentEnterprise?.name} / {currentPlatformGroup?.name}</Text>
                        </div>
                        <div style={{ marginBottom: 24 }}>
                            <Form layout="inline">
                                <Form.Item label="登录账号">
                                    <Input placeholder="请输入登录账号" prefix={<SearchOutlined />} allowClear />
                                </Form.Item>
                                <Form.Item>
                                    <Space>
                                        <Button type="primary">查询</Button>
                                        <Button icon={<ReloadOutlined />}>重置</Button>
                                    </Space>
                                </Form.Item>
                            </Form>
                        </div>

                        <div style={{ marginBottom: 16 }}>
                            <Space size={12}>
                                <Button type="primary" onClick={() => {
                                    platformAccountForm.resetFields();
                                    setIsPlatformAddAccountModalVisible(true);
                                }}>
                                    添加产测账号
                                </Button>
                                <Button
                                    style={{
                                        backgroundColor: platformSelectedRowKeys.length >= 1 ? '#faad14' : '#f5f5f5',
                                        borderColor: platformSelectedRowKeys.length >= 1 ? '#faad14' : '#d9d9d9',
                                        color: platformSelectedRowKeys.length >= 1 ? '#fff' : 'rgba(0, 0, 0, 0.25)',
                                        borderRadius: '4px'
                                    }}
                                    disabled={platformSelectedRowKeys.length === 0}
                                    onClick={() => {
                                        platformMoveForm.resetFields();
                                        setIsPlatformMoveGroupModalVisible(true);
                                    }}
                                >
                                    移动分组
                                </Button>
                            </Space>
                        </div>

                        <Table
                            rowSelection={platformRowSelection}
                            columns={platformColumns}
                            dataSource={platformAccountsData[platformSelectedGroup] || []}
                            rowKey="id"
                            pagination={{
                                showSizeChanger: true,
                                showTotal: (total) => `共 ${total} 条记录`,
                            }}
                        />
                    </Card>
                )}
            </Content>
        </Layout>
    );

    return (
        <ConfigProvider locale={zhCN}>
            <div style={{ minHeight: '100vh', background: '#fff', padding: '24px' }}>
                {/* 顶部 mock 身份切换 */}
                <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                    <Text style={{ marginRight: 12 }}>mock身份</Text>
                    <Segmented
                        value={identity}
                        onChange={setIdentity}
                        options={[
                            { label: '企业用户', value: 'enterprise' },
                            { label: '平台用户', value: 'platform' },
                        ]}
                    />
                </div>

                {identity === 'enterprise' ? renderEnterprise() : renderPlatform()}

                {/* ============ 企业用户弹窗 ============ */}
                {/* 移动分组弹窗（企业） */}
                <Modal
                    title="移动分组"
                    open={isMoveGroupModalVisible}
                    onCancel={() => setIsMoveGroupModalVisible(false)}
                    onOk={handleEnterpriseMoveGroup}
                    okText="保存"
                    cancelText="取消"
                    bodyStyle={{ paddingTop: '24px' }}
                >
                    <Form
                        form={moveGroupForm}
                        layout="horizontal"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                    >
                        <Form.Item
                            label="目标分组"
                            name="targetGroup"
                            rules={[{ required: true, message: '请选择目标分组' }]}
                            style={{ marginBottom: '16px' }}
                        >
                            <Select placeholder="请选择目标分组">
                                {groups.filter(g => g.id !== selectedGroup).map(g => (
                                    <Option key={g.id} value={g.id}>{g.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Form>
                </Modal>

                {/* 新增账号弹窗（企业） */}
                <Modal
                    title="添加产测账号"
                    open={isAddAccountModalVisible}
                    onCancel={() => setIsAddAccountModalVisible(false)}
                    onOk={handleEnterpriseAddAccount}
                    okText="保存"
                    cancelText="取消"
                    bodyStyle={{ paddingTop: '24px' }}
                >
                    <Form
                        form={form}
                        layout="horizontal"
                        initialValues={{ status: true }}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                        style={{ rowGap: '16px' }}
                    >
                        <Form.Item label="登录账号" name="account" rules={[{ required: true, message: '请输入登录账号' }]} style={{ marginBottom: '24px' }}>
                            <Input placeholder="建议使用：厂区_员工名_工台号" />
                        </Form.Item>
                        <Form.Item label="登录密码" name="password" rules={[{ required: true, message: '请输入登录密码' }]} style={{ marginBottom: '24px' }}>
                            <Input.Password placeholder="请输入初始密码" />
                        </Form.Item>
                        <Form.Item label="账号分组" name="group" style={{ marginBottom: '24px' }}>
                            <Input disabled />
                        </Form.Item>
                        <Form.Item label="可用状态" name="status" valuePropName="checked" style={{ marginBottom: '24px' }}>
                            <Switch checkedChildren="开" unCheckedChildren="关" />
                        </Form.Item>
                        <Form.Item label="备注信息" name="remark" style={{ marginBottom: '8px' }}>
                            <TextArea placeholder="请输入备注信息" rows={3} maxLength={200} showCount />
                        </Form.Item>
                    </Form>
                </Modal>

                {/* 分组操作弹窗（企业） */}
                <Modal
                    title={editingGroup ? '修改分组名称' : '新增分组'}
                    open={isGroupModalVisible}
                    onCancel={() => setIsGroupModalVisible(false)}
                    onOk={handleGroupSubmit}
                    okText="保存"
                    cancelText="取消"
                    bodyStyle={{ paddingTop: '24px' }}
                >
                    <Form
                        form={groupForm}
                        layout="horizontal"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                    >
                        <Form.Item label="分组名称" name="name" rules={[{ required: true, message: '请输入分组名称' }]} style={{ marginBottom: '16px' }}>
                            <Input placeholder="输入分组名称，如：东莞一号仓库" maxLength={20} showCount />
                        </Form.Item>
                    </Form>
                </Modal>

                {/* ============ 平台用户弹窗 ============ */}
                {/* 创建分组弹窗（平台）：需先选企业 */}
                <Modal
                    title="新增分组"
                    open={isPlatformGroupModalVisible}
                    onCancel={() => setIsPlatformGroupModalVisible(false)}
                    onOk={handlePlatformGroupSubmit}
                    okText="保存"
                    cancelText="取消"
                    bodyStyle={{ paddingTop: '24px' }}
                >
                    <Form
                        form={platformGroupForm}
                        layout="horizontal"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                    >
                        <Form.Item
                            label="企业"
                            name="enterpriseId"
                            rules={[{ required: true, message: '请选择企业' }]}
                            style={{ marginBottom: '16px' }}
                        >
                            <Select
                                placeholder="请选择企业（支持模糊查询）"
                                showSearch
                                filterOption={enterpriseFilterOption}
                            >
                                {enterpriseOptions}
                            </Select>
                        </Form.Item>
                        <Form.Item label="分组名称" name="name" rules={[{ required: true, message: '请输入分组名称' }]} style={{ marginBottom: '16px' }}>
                            <Input placeholder="输入分组名称，如：东莞一号仓库" maxLength={20} showCount />
                        </Form.Item>
                    </Form>
                </Modal>

                {/* 移动分组弹窗（平台）：先选企业，再选目标分组 */}
                <Modal
                    title="移动分组"
                    open={isPlatformMoveGroupModalVisible}
                    onCancel={() => setIsPlatformMoveGroupModalVisible(false)}
                    onOk={handlePlatformMoveGroup}
                    okText="保存"
                    cancelText="取消"
                    bodyStyle={{ paddingTop: '24px' }}
                >
                    <Form
                        form={platformMoveForm}
                        layout="horizontal"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                    >
                        <Form.Item
                            label="企业"
                            name="enterpriseId"
                            rules={[{ required: true, message: '请选择企业' }]}
                            style={{ marginBottom: '16px' }}
                        >
                            <Select
                                placeholder="请选择企业（支持模糊查询）"
                                showSearch
                                filterOption={enterpriseFilterOption}
                            >
                                {enterpriseOptions}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="目标分组"
                            name="targetGroupId"
                            rules={[{ required: true, message: '请选择目标分组' }]}
                            style={{ marginBottom: '16px' }}
                        >
                            <Select
                                placeholder="请先选择企业"
                                disabled={!platformMoveEnterpriseId}
                            >
                                {getPlatformGroupOptions(platformMoveEnterpriseId)
                                    .filter(g => g.id !== platformSelectedGroup)
                                    .map(g => (
                                        <Option key={g.id} value={g.id}>{g.name}</Option>
                                    ))}
                            </Select>
                        </Form.Item>
                    </Form>
                </Modal>

                {/* 新增账号弹窗（平台）：先选企业，再选账号分组 */}
                <Modal
                    title="添加产测账号"
                    open={isPlatformAddAccountModalVisible}
                    onCancel={() => setIsPlatformAddAccountModalVisible(false)}
                    onOk={handlePlatformAddAccount}
                    okText="保存"
                    cancelText="取消"
                    bodyStyle={{ paddingTop: '24px' }}
                >
                    <Form
                        form={platformAccountForm}
                        layout="horizontal"
                        initialValues={{ status: true }}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                        style={{ rowGap: '16px' }}
                    >
                        <Form.Item label="登录账号" name="account" rules={[{ required: true, message: '请输入登录账号' }]} style={{ marginBottom: '24px' }}>
                            <Input placeholder="建议使用：厂区_员工名_工台号" />
                        </Form.Item>
                        <Form.Item label="登录密码" name="password" rules={[{ required: true, message: '请输入登录密码' }]} style={{ marginBottom: '24px' }}>
                            <Input.Password placeholder="请输入初始密码" />
                        </Form.Item>
                        <Form.Item
                            label="企业"
                            name="enterpriseId"
                            rules={[{ required: true, message: '请选择企业' }]}
                            style={{ marginBottom: '24px' }}
                        >
                            <Select
                                placeholder="请选择企业（支持模糊查询）"
                                showSearch
                                filterOption={enterpriseFilterOption}
                            >
                                {enterpriseOptions}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="账号分组"
                            name="groupId"
                            rules={[{ required: true, message: '请选择账号分组' }]}
                            style={{ marginBottom: '24px' }}
                        >
                            <Select
                                placeholder="请先选择企业"
                                disabled={!platformAccountEnterpriseId}
                            >
                                {getPlatformGroupOptions(platformAccountEnterpriseId).map(g => (
                                    <Option key={g.id} value={g.id}>{g.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="可用状态" name="status" valuePropName="checked" style={{ marginBottom: '24px' }}>
                            <Switch checkedChildren="开" unCheckedChildren="关" />
                        </Form.Item>
                        <Form.Item label="备注信息" name="remark" style={{ marginBottom: '8px' }}>
                            <TextArea placeholder="请输入备注信息" rows={3} maxLength={200} showCount />
                        </Form.Item>
                    </Form>
                </Modal>

                {/* 重置密码弹窗（共享） */}
                <Modal
                    title={`重置密码 - ${currentAccount?.account}`}
                    open={isResetPwdModalVisible}
                    onCancel={() => setIsResetPwdModalVisible(false)}
                    onOk={() => {
                        resetPwdForm.validateFields().then(() => {
                            message.success('密码重置成功');
                            setIsResetPwdModalVisible(false);
                            resetPwdForm.resetFields();
                        });
                    }}
                    okText="保存"
                    cancelText="取消"
                    bodyStyle={{ paddingTop: '24px' }}
                >
                    <Form
                        form={resetPwdForm}
                        layout="horizontal"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 16 }}
                    >
                        <Form.Item
                            label="新密码"
                            name="newPassword"
                            rules={[{ required: true, message: '请输入新密码' }, { min: 6, message: '密码长度不能少于6位' }]}
                            style={{ marginBottom: '16px' }}
                        >
                            <Input.Password placeholder="请输入新密码" prefix={<LockOutlined />} />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </ConfigProvider>
    );
};

export default ProduceAccount;
